export const PERSON_NAME_REGEX = /^[\p{L}\p{M}''\-\s.]+$/u;
export const PERSON_NAME_REGEX_MESSAGE =
  "Letters, hyphens, apostrophes, accented characters and periods only";

export const BUSINESS_NAME_REGEX = /^[\p{L}\p{M}&0-9''\-\s.,]+$/u;
export const BUSINESS_NAME_REGEX_MESSAGE =
  "Letters, numbers, hyphens, apostrophes, periods, commas and ampersands only";
